import React, { useState } from 'react';
import { TextInput } from 'design-system';
import { XButton } from './XButton';

import { Transforms } from 'slate';
import { useSlate, ReactEditor } from 'slate-react';
// eslint-disable-next-line restrict-imports/restrict-imports
import theme from 'design-system/product/theme';

interface IframeSectionProps {
  attributes: $FIXME;
  children: Record<string, any>[];
  element: $FIXME;
  readOnly: boolean;
  setInfoMsg?: (s: string) => void;
}
export const IframeSection: React.FC<IframeSectionProps> = ({
  attributes,
  children,
  element,
  readOnly,
  setInfoMsg,
}) => {
  const { url } = element;
  const editor = useSlate();
  const [urlState, setUrl] = useState(url);

  return (
    <div {...attributes} style={{ border: '1px solid #E6E6E6' }}>
      {!readOnly && (
        <div style={{ display: 'flex' }}>
          <div style={{ left: '96%', position: 'relative', color: theme.colors.primary1 }}>
            <XButton
              onClick={() => {
                Transforms.delete(editor, { at: ReactEditor.findPath(editor, element) });
              }}
            />
          </div>
          <div contentEditable={false} style={{ width: '90%', display: 'flex' }}>
            <div style={{ opacity: 0.5, fontSize: '16px', paddingRight: '8px', paddingTop: '8px' }}>
              url:
            </div>
            <div style={{ paddingTop: '4px', width: '100%' }}>
              <TextInput
                placeholder="Enter publicly accessible url to embed in this iframe"
                fullWidth
                autoFocus={false}
                value={urlState}
                onChange={e => {
                  e.preventDefault();
                  setUrl(e.target.value);
                  const path = ReactEditor.findPath(editor, element);
                  Transforms.setNodes(editor, { url: e.target.value }, { at: path });
                }}
                onBlur={_e => {
                  if (setInfoMsg) {
                    setInfoMsg('Please make sure your url is publicly accessible!');
                    setTimeout(() => setInfoMsg(''), 5000);
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div contentEditable={false}>
        <div
          style={{
            padding: '75% 0 0 0',
            position: 'relative',
          }}
        >
          <iframe
            src={url}
            frameBorder="0"
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
            }}
          />
        </div>
      </div>
      {children}
    </div>
  );
};
